import * as React from 'react';
import * as moment from "moment";
import * as DTOS from "../../../FeralScan.dtos";
import ModalMessage from '../../Common/Modal';
import PaginatedTable, { ISortOption } from '../PaginatedTable/PaginatedTable';
import { Link } from 'react-router-dom';
import { PlotEventSortBy, sortPlotEvents, SortByDirection } from '../../../helpers/graphHelper';

interface IPlotEventListProps {
    className?: string;
    dateTimeFormat: string;
    hidePaginationControls: boolean;
    hideSortControls: boolean;
    plotEvents: any;
    plotEventsLoading: boolean;
    showUser?: boolean;
}

interface IPlotEventListActions {
    onDeletePlotEvent: Function;
}

type PlotEventListItemProps = IPlotEventListProps & IPlotEventListActions;

interface IPlotEventListState {
    showDeleteModal: boolean;
    deletePlotEventId: number;
}


class PlotEventList extends React.PureComponent<PlotEventListItemProps, IPlotEventListState> {
    constructor(props, context) {
        super(props, context);

        this.state = { showDeleteModal: false, deletePlotEventId: undefined };

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onDeleteHideModel = this.onDeleteHideModel.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
    }

    onDeleteItem() {
        this.props.onDeletePlotEvent(this.state.deletePlotEventId);
        this.onDeleteHideModel();
    }

    onDeleteClicked(plotEventId) {
        this.setState({ showDeleteModal: true, deletePlotEventId: plotEventId });
    }

    onDeleteHideModel() {
        this.setState({ showDeleteModal: false, deletePlotEventId: undefined });
    }

    render() {
        const { className, hidePaginationControls, hideSortControls, plotEvents, plotEventsLoading } = this.props;

        const SortPlotEventsChoices: ISortOption[] = [
            { value: PlotEventSortBy.EVENTSTARTDATE, label: 'Date of Scan' },
            { value: PlotEventSortBy.CREATEDDATE, label: 'Date Uploaded' },
        ]

        return (
            <div className={className}>
                <PaginatedTable
                    countPerPage={25}
                    data={plotEvents}
                    dataColumns={[
                        {
                            label: "Date Uploaded",
                            dataKey: undefined,
                            render: (pe) => moment(pe.createdDate).format(this.props.dateTimeFormat)
                        },
                        {
                            label: "Date of Scan",
                            dataKey: undefined,
                            render: (pe) => moment(pe.eventStartDate).format(this.props.dateTimeFormat)
                        },
                        {
                            label: "Platypus Seen",
                            dataKey: undefined,
                            render: (pe) => <span>{pe.questionResults.find(q => q.questionCode === "PlatypusAbundance").value}</span>
                        },
                        {
                            label: "ID",
                            dataKey: undefined,
                            disabled: !this.props.showUser,
                            render: (pe) => <Link to={`/admin/user/${pe.userId}`}>{pe.userId}</Link>
                        },
                        {
                            label: "Surname",
                            dataKey: undefined,
                            disabled: !this.props.showUser,
                            render: (pe) => <Link to={`/admin/user/${pe.userId}`}>{pe.surname}</Link>
                        },
                        {
                            label: "Delete",
                            dataKey: undefined,
                            render: (pe: DTOS.PlotEvent) => <span>
                                <i className="fa fa-trash fa-lg ml-1 clickable" onClick={() => this.onDeleteClicked(pe.id)} />
                            </span>
                        }
                    ]}
                    dataLoading={plotEventsLoading}
                    dataSortOptions={hideSortControls ? undefined : SortPlotEventsChoices}
                    defaultSortDirection={SortByDirection.DESC}
                    hidePaginationControls={hidePaginationControls}
                    sort={sortPlotEvents}
                    tableClassName={"table-sm table-bordered table-hover"}
                />

                <ModalMessage
                    onRequestClose={this.onDeleteHideModel}
                    onNegativeResponse={this.onDeleteHideModel}
                    onPositiveResponse={this.onDeleteItem}
                    isOpen={this.state.showDeleteModal}
                    label="Delete Plot Event"
                    message="Are you sure you want to delete this event?"

                    positiveResponseLabel="Delete"
                    positiveResponseClass="btn-danger"
                    negativeResponseLabel="Cancel"
                    negativeResponseClass="btn-secondary"
                />
            </div>
        );
    }
}

export default PlotEventList;
